









































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({})
export default class TableComponent extends Vue {
    @Prop() public loading: boolean;

    @Prop({ default: true })
    public selectable: boolean;

    @Prop() public items: any[];

    @Prop() public selected: number[];

    @Prop() public propertyId: any;

    @Prop() public printVersion: boolean;

    @Prop({ default: false }) public shrink: boolean;

    @Prop({ default: false }) public overflowVisible: boolean;

    @Prop({ default: false }) public small: boolean;

    @Prop({ default: true }) public smallRows: boolean;

    get empty(): boolean {
        return !this.items || !this.items.length;
    }

    get showEmpty(): boolean {
        return !this.loading && this.empty;
    }

    get selectAll(): boolean {
        return this.items ? this.selected.length === this.items.length : false;
    }

    set selectAll(value: boolean) {
        let selected = [];

        if (value) {
            this.items.forEach((item) => {
                selected.push(item[this.propertyId]);
            });
        }

        this.select(selected);
    }

    @Emit()
    public select(selected: number[]) {
        // emit
    }
}
